import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { CheckCircle2 } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { submitAppointment } from '../services/api';
import { specialties } from './Header';

const schema = z.object({
  patient_name: z.string().min(2, 'Please enter your name'),
  phone: z.string().min(10, 'Enter a valid phone number'),
  email: z.string().email('Enter a valid email'),
  department: z.string().min(1, 'Choose a department'),
  appointment_date: z.string().min(1, 'Choose a date')
});

export default function AppointmentForm({ compact = false }) {
  const [sent, setSent] = useState(false);
  const [searchParams] = useSearchParams();
  const selectedService = searchParams.get('specialty') || '';
  const options = specialties.includes(selectedService) || !selectedService ? specialties : [selectedService, ...specialties];
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm({ resolver: zodResolver(schema), defaultValues: { department: selectedService } });
  const onSubmit = async (values) => {
    try { await submitAppointment({ ...values, status: 'pending' }); }
    catch { localStorage.setItem('asian_axxon_last_appointment', JSON.stringify(values)); }
    setSent(true);
  };
  if (sent) return <div className="form-success"><CheckCircle2/><h3>Request received</h3><p>Our care team will call you shortly to confirm the appointment.</p></div>;
  return <form className={compact ? 'appointment-form compact' : 'appointment-form'} onSubmit={handleSubmit(onSubmit)}>
    <label>Full name<input placeholder="Your name" {...register('patient_name')}/><i>{errors.patient_name?.message}</i></label>
    <label>Phone<input placeholder="+91" {...register('phone')}/><i>{errors.phone?.message}</i></label>
    <label>Email<input placeholder="you@example.com" {...register('email')}/><i>{errors.email?.message}</i></label>
    <label>Specialty or service<select {...register('department')}><option value="">Select specialty or service</option>{options.map(option=><option key={option}>{option}</option>)}</select><i>{errors.department?.message}</i></label>
    <label>Preferred date<input type="date" {...register('appointment_date')}/><i>{errors.appointment_date?.message}</i></label>
    <button className="btn btn-primary" disabled={isSubmitting}>{isSubmitting ? 'Sending…' : 'Request appointment'}</button>
  </form>;
}
